import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { getAppContext } from '@b2ag/micro-front-tools'
import { getAnalyticsMetaDataPayload } from '@b2ag/analytics/src/analytics-agri'
import { trackPageView } from '@b2ag/analytics/src/usePageAnalytics'
import { locationStorage } from '../services'
import { checkAndRedirectIfUserIsNotOnCorrectLocalizedRoute } from '@b2ag/utils/src/i18n-routing'

const { isFrontAgri } = getAppContext()

export async function routerAfterEach({ storeInstance }, to, from) {
  if (import.meta.server) return

  if (!window.location.href.includes('oauth')) {
    checkAndRedirectIfUserIsNotOnCorrectLocalizedRoute(storeInstance.getters.user?.currentProfile?.cooperative?.locales)
  }

  setTimeout(() => {
    if (isFrontAgri) {
      const metaData = getAnalyticsMetaDataPayload(to, from, storeInstance)
      useAnalyticService().trackEvent('page_view', metaData)
    } else {
      trackPageView(to, from, storeInstance)
    }
  }, 1000)

  setTimeout(() => {
    window.prerenderReady = true
  }, 100)

  if (to.meta.storePathBeforeAuth) {
    locationStorage.storeLocation('/')
  }
}
